// Third-party
import React from 'react';
import { useDispatch } from 'react-redux';

// Redux actions
import { removePortfolioPlanAccount } from '@/redux/modules/edit-portfolio';

// Types
import { Dispatch } from '@/redux';

// Components
import { SecondaryButton } from '@/views/components/buttons';
import DropdownButton from '@/views/components/buttons/DropdownButton';
import PlanAccountLabel from './components/PlanAccountLabel';

// Types
import { Account } from '@/types/planning';

// Utils
import { FormattedMessage } from '@/utils/i18n';
import GenericContact from '@/types/generic-contact';
import { useContactPlanAccounts } from '@/hooks/planning/useContactPlanAccounts';

type StateProps = {
  importedAccounts?: Account[];
  planId?: string;
};

type Props = {
  planAccountId?: string;
  contact?: GenericContact;
  onChangePlanAccount: () => void;
} & StateProps;

const PortfolioEditorPlanAccountPicker: React.FC<Props> = ({ contact, planAccountId, onChangePlanAccount }: Props) => {
  const dispatch = useDispatch<Dispatch>();
  const { isLoading, selectedAccount } = useContactPlanAccounts({ contact, selectedPlanAccountId: planAccountId });
  const planAccountDropdownItems = [
    {
      node: <FormattedMessage id="PortfolioEditorBuilder.PlanAccount.ChangePlanAccount" />,
      onClick: () => onChangePlanAccount(),
    },
    ...(planAccountId
      ? [
          {
            node: (
              <span className="remove-plan-account-label">
                <FormattedMessage id="PortfolioEditorBuilder.PlanAccount.RemovePlanAccount" />
              </span>
            ),
            onClick: () => dispatch(removePortfolioPlanAccount()),
          },
        ]
      : []),
  ];

  return (
    <div className="portfolio-editor-plan-account">
      <div className="account-display-select">
        {!planAccountId && (
          <SecondaryButton className="secondary-v2 select-account-btn" onClick={onChangePlanAccount}>
            <PlanAccountLabel selectedAccount={selectedAccount} isLoading={isLoading} />
          </SecondaryButton>
        )}
        {planAccountId && (
          <DropdownButton toggle={{ component: SecondaryButton, className: 'secondary-v2' }} align="end" items={planAccountDropdownItems}>
            <PlanAccountLabel selectedAccount={selectedAccount} isLoading={isLoading} />
          </DropdownButton>
        )}
      </div>
    </div>
  );
};

export default PortfolioEditorPlanAccountPicker;
